import { render, staticRenderFns } from "./AdjustKFBConfiguration.vue?vue&type=template&id=81010cd6"
import script from "./AdjustKFBConfiguration.vue?vue&type=script&lang=js"
export * from "./AdjustKFBConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports